
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"14","viewBox":"0 0 14 14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.554 13.4c1.393 0 2.082-.723 2.082-2.155v-8.49c0-1.432-.69-2.155-2.082-2.155H2.082C.696.6 0 1.316 0 2.755v8.49C0 12.684.696 13.4 2.082 13.4h11.472zM5.835 9.381V4.62c0-.341.378-.55.677-.369l3.82 2.378a.448.448 0 010 .758L6.511 9.75a.432.432 0 01-.677-.369z","fill":"#1AAA97","fill-rule":"nonzero"}})])
          )
        }
      }
    